var _path, _g, _g2, _path2, _path3, _path4, _path5, _g3, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _ellipse, _path20;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSuccessfullyApplied(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 384.088,
    height: 302.787,
    viewBox: "0 0 384.088 302.787",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group_18449",
    "data-name": "Group 18449",
    transform: "translate(-735.441 -464.292)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2168",
    "data-name": "Path 2168",
    d: "M545.286,785.2c-.344,1.018-196.464,1.017-196.835,0C348.794,784.187,544.914,784.187,545.286,785.2Z",
    transform: "translate(450 -19.173)",
    fill: "#ccc"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_18447",
    "data-name": "Group 18447",
    transform: "translate(883.439 709.423)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M898.848,585.243s4.251-14.428-.8-25.053a22.793,22.793,0,0,1-1.844-14.3,38.35,38.35,0,0,1,2.023-6.711",
    transform: "translate(-888.387 -527.87)",
    fill: "none",
    stroke: "#535461",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M892.72,511.436c0,1.77,3.206,6.9,3.206,6.9s3.206-5.13,3.206-6.9a3.206,3.206,0,1,0-6.412,0Z",
    transform: "translate(-886.016 -508.23)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M909.747,538.048c.962,1.484,6.438,4.049,6.438,4.049s-.1-6.047-1.061-7.531a3.206,3.206,0,1,0-5.377,3.482Z",
    transform: "translate(-908.336 -524.892)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M906.441,588.282c1.581.8,7.6.247,7.6.247s-3.139-5.168-4.716-5.963a3.206,3.206,0,0,0-2.886,5.72Z",
    transform: "translate(-904.8 -558.103)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M897,628.336c1.424,1.052,7.451,1.526,7.451,1.526s-2.219-5.624-3.642-6.675A3.206,3.206,0,0,0,897,628.336Z",
    transform: "translate(-892.325 -584.577)",
    fill: "#93d502"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M891.981,550.612c-1.282,1.231-7.179,2.51-7.179,2.51s1.446-5.871,2.716-7.1a3.206,3.206,0,1,1,4.463,4.595Z",
    transform: "translate(-877.409 -533)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M880.2,595.973c-1.581.8-7.6.247-7.6.247s3.139-5.168,4.716-5.964a3.206,3.206,0,0,1,2.886,5.72Z",
    transform: "translate(-862.277 -563.277)",
    fill: "#93d502"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M877.428,642.906c-1.424,1.052-7.451,1.526-7.451,1.526s2.232-5.627,3.642-6.678a3.206,3.206,0,0,1,3.809,5.152Z",
    transform: "translate(-858.22 -594.463)",
    fill: "#017572"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_18448",
    "data-name": "Group 18448",
    transform: "translate(932.147 658.533)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54-2",
    "data-name": "Path 54",
    d: "M898.938,626.1s-8.022-27.225,1.507-47.275a43.009,43.009,0,0,0,3.479-26.983,72.316,72.316,0,0,0-3.818-12.663",
    transform: "translate(-880.169 -517.839)",
    fill: "none",
    stroke: "#535461",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55-2",
    "data-name": "Path 55",
    d: "M904.82,514.28c0,3.34-6.05,13.014-6.05,13.014s-6.05-9.68-6.05-13.014a6.05,6.05,0,0,1,12.1,0Z",
    transform: "translate(-878.96 -508.23)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56-2",
    "data-name": "Path 56",
    d: "M921.3,542.544c-1.815,2.8-12.148,7.641-12.148,7.641s.187-11.41,2-14.212a6.05,6.05,0,1,1,10.146,6.57Z",
    transform: "translate(-885.45 -517.72)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57-2",
    "data-name": "Path 57",
    d: "M919.145,593.606c-2.983,1.5-14.345.466-14.345.466s5.923-9.753,8.9-11.253a6.05,6.05,0,0,1,5.445,10.793Z",
    transform: "translate(-883.731 -536.657)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58-2",
    "data-name": "Path 58",
    d: "M909.88,633.382c-2.686,1.984-14.061,2.88-14.061,2.88s4.187-10.612,6.873-12.6a6.05,6.05,0,0,1,7.188,9.716Z",
    transform: "translate(-880.184 -550.808)",
    fill: "#93d502"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59-2",
    "data-name": "Path 59",
    d: "M886.846,555.584c2.42,2.323,13.546,4.737,13.546,4.737s-2.729-11.078-5.124-13.4a6.05,6.05,0,1,0-8.422,8.67Z",
    transform: "translate(-875.832 -522.349)",
    fill: "#017572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60-2",
    "data-name": "Path 60",
    d: "M875.7,601.3c2.983,1.5,14.345.466,14.345.466s-5.923-9.753-8.9-11.253A6.05,6.05,0,0,0,875.7,601.3Z",
    transform: "translate(-871.013 -539.599)",
    fill: "#93d502"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61-2",
    "data-name": "Path 61",
    d: "M872.242,647.969c2.686,1.984,14.06,2.88,14.06,2.88s-4.211-10.618-6.873-12.6a6.05,6.05,0,0,0-7.187,9.722Z",
    transform: "translate(-869.977 -556.556)",
    fill: "#017572"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2169",
    "data-name": "Path 2169",
    d: "M638.246,574.46a47.876,47.876,0,1,1,47.872-47.876A47.874,47.874,0,0,1,638.246,574.46Zm0-90.258a42.382,42.382,0,1,0,42.378,42.382A42.38,42.38,0,0,0,638.246,484.2Z",
    transform: "translate(276.954 58.181)",
    fill: "#01a9e0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2170",
    "data-name": "Path 2170",
    d: "M615.126,526.315c-.1,0-.193,0-.289-.008a5.9,5.9,0,0,1-4.375-2.273l-7.541-9.7a5.905,5.905,0,0,1,1.035-8.286l.272-.211a5.9,5.9,0,0,1,8.288,1.036,4.306,4.306,0,0,0,6.521.317l15.312-16.166a5.912,5.912,0,0,1,8.348-.226l.251.239a5.9,5.9,0,0,1,.226,8.347L619.41,524.471A5.9,5.9,0,0,1,615.126,526.315Z",
    transform: "translate(291.966 77.014)",
    fill: "#01a9e0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2171",
    "data-name": "Path 2171",
    d: "M654.717,607.4a64.348,64.348,0,1,1,64.343-64.348A64.346,64.346,0,0,1,654.717,607.4Zm0-121.312a56.964,56.964,0,1,0,56.959,56.964,56.962,56.962,0,0,0-56.959-56.964Z",
    transform: "translate(260.483 41.709)",
    fill: "#01a9e0",
    opacity: 0.146
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2172",
    "data-name": "Path 2172",
    d: "M672.247,642.467a81.879,81.879,0,1,1,81.872-81.879A81.876,81.876,0,0,1,672.247,642.467Zm0-154.363a72.483,72.483,0,1,0,72.477,72.483A72.48,72.48,0,0,0,672.247,488.1Z",
    transform: "translate(242.954 24.179)",
    fill: "#01a9e0",
    opacity: 0.054
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_18445",
    "data-name": "Group 18445",
    transform: "translate(735.441 514.222)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2132",
    "data-name": "Path 2132",
    d: "M386.129,688.675a1.618,1.618,0,0,1-1.172-2.8l.111-.441a4.346,4.346,0,0,0-8.057-.076c-1.917,4.487-4.4,9.133-3.164,14.075-8.151-17.274-5.379-38.762,6.667-53.534a13.259,13.259,0,0,0,6.731-8.876c-1.648.558-3.7-.782-2.463-2.518.537-.663,1.079-1.322,1.616-1.985-6.259-6.666-13.717,3.811-6.828,12.808a51.86,51.86,0,0,0-5.825,9.111,21.808,21.808,0,0,0-1.3-10.129c-1.246-3.006-3.582-5.538-5.639-8.137a4.476,4.476,0,0,0-7.984,2.313c2.308.759,2.608,4.092-.032,4.549a22.325,22.325,0,0,0,12.3,17.624,52.065,52.065,0,0,0-2.845,21.763c-1.187-8.618-10.438-10.709-16.9-14.135a2.519,2.519,0,0,0-3.841,2.551,14.553,14.553,0,0,1,2.55,1.345,2.2,2.2,0,0,1-1.021,4.014,22.2,22.2,0,0,0,20.34,13.453,53.532,53.532,0,0,0,3.6,10.5h12.845c.046-.143.087-.29.129-.433a14.59,14.59,0,0,1-3.554-.212c3.146-3.724,5.578-5.624,3.748-10.824Z",
    transform: "translate(-310.387 -448.32)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2138",
    "data-name": "Path 2138",
    d: "M504.033,387.788l-1.366-7.919,20.772-9.38,4.486-7.942a3.862,3.862,0,1,1,5.7,2.563l-7.379,11.408Z",
    transform: "translate(-396.109 -297.81)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2139",
    "data-name": "Path 2139",
    d: "M226.971,292.157l9.354-4.778,2.476,9.3-6.5,4.816Z",
    transform: "translate(-125.362 -208.653)",
    fill: "#0b132b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2140",
    "data-name": "Path 2140",
    d: "M180.084,624.148h5.656l2.691-21.815h-8.348Z",
    transform: "translate(-99.465 -382.606)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2141",
    "data-name": "Path 2141",
    d: "M449.145,759.618v-3.834l-1.487.091-6.053.358-1.4.086-1.071,12.841-.057.689h4.016l.129-.684.583-3.108,1.506,3.108.33.684h10.647a2.406,2.406,0,0,0,2.39-2.4C459.128,765.355,450.273,760.818,449.145,759.618Z",
    transform: "translate(-360.988 -517.567)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2142",
    "data-name": "Path 2142",
    d: "M28.5,457.676l-1.318,5.5,20.587,7.7,1.946-8.117Z",
    transform: "translate(-15.014 -302.71)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2143",
    "data-name": "Path 2143",
    d: "M276.328,570.912l3.729.894.258-1.467,1.063-5.969.243-1.382-12.238-4.035-.656-.216-.936,3.905.635.285,2.886,1.292-3.373.74-.742.161-2.483,10.354a2.406,2.406,0,0,0,1.772,2.883C268.421,579.281,274.9,571.729,276.328,570.912Z",
    transform: "translate(-264.65 -408.734)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2144",
    "data-name": "Path 2144",
    d: "M419.534,443.641l-7.28-3.4-14.518,17.569-8.843,2.236a3.862,3.862,0,1,0,.971,6.177l12.949-4.115Z",
    transform: "translate(-330.17 -343.287)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2147",
    "data-name": "Path 2147",
    d: "M598.177,494.313a7.8,7.8,0,1,1,7.8-7.8A7.8,7.8,0,0,1,598.177,494.313Zm0-14.709a6.907,6.907,0,1,0,6.907,6.907,6.907,6.907,0,0,0-6.907-6.907Z",
    transform: "translate(-444.551 -364.535)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2148",
    "data-name": "Path 2148",
    d: "M603.868,495.237h-.047a.962.962,0,0,1-.713-.37l-1.229-1.58a.962.962,0,0,1,.169-1.35l.044-.034a.962.962,0,0,1,1.351.169.7.7,0,0,0,1.063.052l2.5-2.635a.964.964,0,0,1,1.36-.037l.041.039a.962.962,0,0,1,.037,1.36l-3.873,4.088A.961.961,0,0,1,603.868,495.237Z",
    transform: "translate(-450.793 -370.322)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2149",
    "data-name": "Path 2149",
    d: "M407.177,259.313a7.8,7.8,0,1,1,7.8-7.8A7.8,7.8,0,0,1,407.177,259.313Zm0-14.709a6.907,6.907,0,1,0,6.907,6.907A6.907,6.907,0,0,0,407.177,244.6Z",
    transform: "translate(-339.06 -234.742)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2150",
    "data-name": "Path 2150",
    d: "M412.868,260.237h-.047a.962.962,0,0,1-.713-.37l-1.229-1.58a.962.962,0,0,1,.169-1.35l.044-.034a.962.962,0,0,1,1.351.169.7.7,0,0,0,1.063.052l2.5-2.635a.964.964,0,0,1,1.361-.037l.041.039a.962.962,0,0,1,.037,1.36l-3.873,4.088A.961.961,0,0,1,412.868,260.237Z",
    transform: "translate(-345.302 -240.529)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2151",
    "data-name": "Path 2151",
    d: "M406.663,517.894c-18.092,0-38.885-20.077-57.281-10.538-55.7,28.882-48.032-19.448-64.034-37.422l.525-1.054c17.656,15.832,39.7,28.713,63.75,37.25,21.733,7.716,43.63,11.291,63.314,10.347l.034,1.267Q409.853,517.9,406.663,517.894Z",
    transform: "translate(-276.082 -359.107)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2837",
    "data-name": "Ellipse 2837",
    cx: 3.782,
    cy: 5.071,
    rx: 3.782,
    ry: 5.071,
    transform: "translate(101.981 12.902)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2152",
    "data-name": "Path 2152",
    d: "M595.418,448.2a1.6,1.6,0,0,1-1.736-2.691A1.6,1.6,0,0,1,595.418,448.2Z",
    transform: "translate(-445.975 -346.046)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2838",
    "data-name": "Ellipse 2838",
    cx: 4.925,
    cy: 4.925,
    rx: 4.925,
    ry: 4.925,
    transform: "translate(134.566 0)",
    fill: "#51cb20"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2839",
    "data-name": "Ellipse 2839",
    cx: 4.791,
    cy: 4.791,
    rx: 4.791,
    ry: 4.791,
    transform: "translate(123.639 122.035)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2154",
    "data-name": "Path 2154",
    d: "M384.766,511.053S372.821,518.831,375.98,524c.109.178-14.268,19.166-14.268,19.166l-27.14-1.723-.956,9.084,24.162,7s5.911,4.343,10.477-.442,19.776-19.437,19.776-19.437l.734,29.582-7.635,40.991,11.4-.723,11.1-41.125,4.1-46.584Z",
    transform: "translate(-302.741 -382.399)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2155",
    "data-name": "Path 2155",
    d: "M445.079,404.342l-5.023,3.807-5.725,12.219,5.505,7.477s4.631,8.026-2.782,15.8-13.1,16.073-7.171,15.777,29.962,11.925,30.12,1.912.478-17.689.478-17.689l6.3-15.978s3.753-9.532,1.118-12.385-6.163-6.5-6.163-6.5l-6.416-6.416h-5.794Z",
    transform: "translate(-354.546 -322.368)",
    fill: "#0b132b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2156",
    "data-name": "Path 2156",
    d: "M469.838,352.769c11.269,6.412,2.018,23.331-9.461,17.306C449.109,363.663,458.359,346.745,469.838,352.769Z",
    transform: "translate(-369.928 -294.272)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2157",
    "data-name": "Path 2157",
    d: "M470.2,350.424c-.79,1.027-2.439.545-5.67,1.278a13.463,13.463,0,0,0-.377-3.251,9.15,9.15,0,0,1-1.543,3.659c-2.805.311.634,8.833-.8,15.1-1.85-13.218-5.743-9.755-3.776-7.133,1.259,1.678.42,6.714-3.357,4.2-6.231,2.961-15.106-11.749-5.27-18.648-.176-3.729,3.973-4.318,6.529-3.172C462.135,337.832,469.22,343.751,470.2,350.424Z",
    transform: "translate(-364.266 -288.372)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2158",
    "data-name": "Path 2158",
    d: "M407.585,339.029c-2.509,15.425-15.956-2.837-22.278,12.343-1.988,5.5,1.423,9.43,3.58,13.993.492,3.75-4.386,5.652-4.9,9.1-.142,7.913,12.625,7.429,16.194,2.436,3.667-5.226-.712-12.239,1.492-17.849,3.1-7.789,15.7-7.846,16.8-16.908C416.346,339.121,410.63,335.654,407.585,339.029Z",
    transform: "translate(-330.562 -286.622)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2159",
    "data-name": "Path 2159",
    d: "M455.76,338.118c-.082.035-.164.069-.238.108h0c-.069.035-.138.069-.207.108l-.022.013c-.091-.086-.181-.173-.276-.259a1,1,0,0,0,.017.423l.013.052c.086.091.177.177.272.268.086-.065.169-.134.255-.2.052-.043.1-.086.16-.13.009-.112.022-.242.035-.385Zm2.6-4.8c-1.927-.441-2.549,2.078-2.734,3.292-.7-4.406-3.611-3.019-2.6-.013a6.731,6.731,0,0,0,1.482,2.384c.091.1.19.207.294.311-.117.6.471.449,1.266-.108a10.582,10.582,0,0,0,1.62-1.421C459.267,336.1,460.5,333.872,458.36,333.315Zm.06,2.479a15.093,15.093,0,0,1-1.991,2.112q-.343.311-.7.6c0,.039,0,.073-.009.1a.8.8,0,0,1-.061.121c-.242.436-.514.2-.618-.164-.009-.013-.022-.026-.03-.039a6.085,6.085,0,0,1-.894-1.184c-1.784-3.093,1.089-5.2.946.579a.55.55,0,0,0-.052.169,1,1,0,0,0,.017.423l.013.052c.086.091.177.177.272.268.086-.065.169-.134.255-.2.052-.043.1-.086.16-.13.009-.112.022-.242.035-.385v0c.112-1.158.419-3.24.985-3.806C457.993,333.354,459.6,334.386,458.421,335.794Zm-2.661,2.324c-.082.035-.164.069-.238.108h0c-.069.035-.138.069-.207.108l-.022.013c-.091-.086-.181-.173-.276-.259a1,1,0,0,0,.017.423l.013.052c.086.091.177.177.272.268.086-.065.169-.134.255-.2.052-.043.1-.086.16-.13.009-.112.022-.242.035-.385Z",
    transform: "translate(-368.574 -284.204)",
    fill: "#2f2e41"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_18446",
    "data-name": "Group 18446",
    transform: "translate(955.253 464.292)"
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2167",
    "data-name": "Path 2167",
    d: "M769.026,448.642c-14.423,10.923-43.12,7.473-52.025,26.184-26.963,56.653-50.031,13.5-73.639,8.83l-.217-1.157c23.633,1.96,48.984-1.081,73.31-8.8,21.983-6.971,41.6-17.341,56.719-29.978l.792.989Q771.569,446.716,769.026,448.642Z",
    transform: "translate(-609.688 -295.282)",
    fill: "#f2f2f2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2133",
    "data-name": "Path 2133",
    d: "M688.251,688.675a1.618,1.618,0,0,0,1.172-2.8l-.111-.441a4.346,4.346,0,0,1,8.057-.076c1.917,4.487,4.4,9.133,3.164,14.075,8.151-17.274,5.379-38.762-6.667-53.534a13.259,13.259,0,0,1-6.731-8.876c1.648.558,3.7-.782,2.464-2.518-.537-.663-1.079-1.322-1.616-1.985,6.259-6.666,13.717,3.811,6.828,12.808a51.864,51.864,0,0,1,5.825,9.111,21.808,21.808,0,0,1,1.3-10.129c1.246-3.006,3.582-5.538,5.639-8.137a4.477,4.477,0,0,1,7.984,2.313c-2.308.759-2.608,4.092.032,4.549a22.325,22.325,0,0,1-12.3,17.624,52.065,52.065,0,0,1,2.845,21.763c1.187-8.618,10.438-10.709,16.9-14.135a2.519,2.519,0,0,1,3.841,2.551,14.554,14.554,0,0,0-2.55,1.345,2.2,2.2,0,0,0,1.021,4.014,22.2,22.2,0,0,1-20.34,13.453,53.536,53.536,0,0,1-3.6,10.5H688.573c-.046-.143-.087-.29-.129-.433A14.59,14.59,0,0,0,692,699.5c-3.146-3.724-5.578-5.624-3.748-10.824Z",
    transform: "translate(-633.985 -398.39)",
    fill: "#f2f2f2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2134",
    "data-name": "Path 2134",
    d: "M419.56,626.347l-5.532,1.258-7.487-20.738,8.164-1.857Z",
    transform: "translate(-360.531 -334.154)",
    fill: "#ffb6b6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2135",
    "data-name": "Path 2135",
    d: "M682.376,768.312l-17.011,3.87-.049-.215a6.79,6.79,0,0,1,5.114-8.128h0L673,760.775l6.334,1.038,1.485-.338Z",
    transform: "translate(-621.84 -470.393)",
    fill: "#2f2e41"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2136",
    "data-name": "Path 2136",
    d: "M612.157,426.88l3.041,4.789-17.025,14.01-4.489-7.069Z",
    transform: "translate(-463.893 -235.771)",
    fill: "#ffb6b6"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2137",
    "data-name": "Path 2137",
    d: "M903.208,531.565l9.352,14.727-.186.118A6.791,6.791,0,0,1,903,544.319h0l-3.749-1.394-1.146-6.315-.817-1.286Z",
    transform: "translate(-750.055 -343.797)",
    fill: "#2f2e41"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2145",
    "data-name": "Path 2145",
    d: "M685.177,283.313a7.8,7.8,0,1,1,7.8-7.8A7.8,7.8,0,0,1,685.177,283.313Zm0-14.709a6.907,6.907,0,1,0,6.907,6.907,6.907,6.907,0,0,0-6.907-6.907Z",
    transform: "translate(-628.594 -198.066)",
    fill: "#e6e6e6"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2146",
    "data-name": "Path 2146",
    d: "M690.868,284.237h-.047a.962.962,0,0,1-.713-.37l-1.229-1.58a.962.962,0,0,1,.169-1.35l.044-.034a.962.962,0,0,1,1.351.169.7.7,0,0,0,1.063.052l2.5-2.635a.964.964,0,0,1,1.361-.037l.041.039a.962.962,0,0,1,.037,1.36l-3.873,4.088A.961.961,0,0,1,690.868,284.237Z",
    transform: "translate(-634.836 -203.853)",
    fill: "#e6e6e6"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2153",
    "data-name": "Path 2153",
    d: "M610.9,193.991l28.022-81.841-30.77,80.862a1.541,1.541,0,1,0,2.748.98Z",
    transform: "translate(-590.179 -112.149)",
    fill: "#f0f0f0",
    opacity: 0.3,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2160",
    "data-name": "Path 2160",
    d: "M662.82,525.206l-4.162,10.853-19.523,38.51,17.155,44.8,8.854-2.337-7.3-42.462,20.936-25.438,24.863,16.863s11.026,8.608,15.221.448S750.2,540.924,750.2,540.924l-6.715-7.163-31.257,14.628-21.574-30.366Z",
    transform: "translate(-607.474 -336.318)",
    fill: "#2f2e41"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2161",
    "data-name": "Path 2161",
    d: "M698.232,408.637l-6.851-7.36-11.752-1.617-14.4,10.081.145,11.158,7.118,26.292s-2.711,18.89,4.862,18.7,11.7-3.965,14.786-3.2,16.2,4.04,17.027.613,5.248-.973,5.054-4.214-11.957-26.6-11.957-26.6l2.925-23.366Z",
    transform: "translate(-621.886 -270.945)",
    fill: "#01a9e0"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2162",
    "data-name": "Path 2162",
    d: "M805.637,339.313a4.2,4.2,0,0,1-4.5,4.6l-15.754,29.962-4.23-6.493,16.1-28.278a4.219,4.219,0,0,1,8.377.205Z",
    transform: "translate(-685.914 -235.502)",
    fill: "#ffb6b6"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2163",
    "data-name": "Path 2163",
    d: "M725.031,393.385s-.625,5.33,5.375,6.649,22.623-8.179,25.348-9.63c.853-.454,2.011-2.681,3.2-5.525.533-1.277,1.073-2.679,1.594-4.1.3-.823,1.744-1.047,2.028-1.863s-.594-2.214-.338-2.979c1.214-3.63,2.074-6.509,2.074-6.509l-3.977-7.47c-5.562,2.94-8.414,9.417-10.512,16.878Z",
    transform: "translate(-654.904 -250.121)",
    fill: "#01a9e0"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2164",
    "data-name": "Path 2164",
    d: "M568.467,353.369a4.2,4.2,0,0,0,5.5,3.332l22.751,25.066,2.47-7.345-22.668-23.348a4.219,4.219,0,0,0-8.059,2.3Z",
    transform: "translate(-568.413 -242.678)",
    fill: "#ffb6b6"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2165",
    "data-name": "Path 2165",
    d: "M643.532,390.358s1.939,5-3.54,7.783-23.95-2.257-26.951-2.98c-.94-.226-2.618-2.092-4.48-4.549-.836-1.1-1.709-2.325-2.569-3.571-.5-.721-1.951-.577-2.43-1.3s.021-2.292-.418-2.969c-2.084-3.21-3.637-5.783-3.637-5.783l1.981-8.227c6.121,1.455,10.5,7.012,14.4,13.711Z",
    transform: "translate(-585.587 -253.881)",
    fill: "#01a9e0"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2840",
    "data-name": "Ellipse 2840",
    cx: 11.182,
    cy: 11.181,
    rx: 11.182,
    ry: 11.181,
    transform: "translate(52.672 104.48)",
    fill: "#ffb6b6"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2166",
    "data-name": "Path 2166",
    d: "M709.076,344.918a5.765,5.765,0,0,0-5.523-2.692,7.542,7.542,0,0,0-12.637-4.4,2.345,2.345,0,0,0-2.294-.23,4.836,4.836,0,0,0-1.863,1.5,10.853,10.853,0,0,0-1.519,11.041c-.261-.951.691-1.845,1.654-2.058s1.972-.012,2.948-.15c1.251-.178,2.376-.9,3.629-1.067a8.261,8.261,0,0,1,3.139.4,8.511,8.511,0,0,0,3.138.421c1.055-.125,2.413,3.872,2.395,6.687,0,.534.106,1.218.628,1.332.642.139,1.014-.747,1.625-.988a1.131,1.131,0,0,1,1.387.737,1.843,1.843,0,0,1-.352,1.651,5.448,5.448,0,0,1-1.321,1.146l.252.209a1.5,1.5,0,0,0,1.89.235,4.08,4.08,0,0,0,1.357-1.546,18.187,18.187,0,0,0,2.49-5.966A8.689,8.689,0,0,0,709.076,344.918Z",
    transform: "translate(-632.459 -235.659)",
    fill: "#2f2e41"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessfullyApplied);
export default __webpack_public_path__ + "static/media/successfully-applied.e76bdb1aa6be1b756d8578fa59e98285.svg";
export { ForwardRef as ReactComponent };